import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useEffectOnce, usePathParam } from '@chilecompra/react-kit'
import { Skeleton, Toast, Typography } from '@chilecompra/react-kit/components'
import { REACT_APP_CENTROAYUDA_BASE_URL } from '../../config/settings/environment'
import { useAuthorization } from '../AuthorizationProvider/AuthorizationProvider.hooks'
import { onGetSellerStampsThunk } from './StampsSection.actions'
import { BookmarkIcon, Box, Container, Content, Link, MoreInformation, Root, Separator } from './StampsSection.styles'

/**
 * The StampsSection's container.
 */
const StampsSection = () => {
  const { userType } = useAuthorization()
  const dispatch = useDispatch()
  const dni = usePathParam('rut')
  const { error, loading, stamps } = useSelector(state => state.stamps)
  const { error: summaryError } = useSelector(state => state.summarySection)

  useEffectOnce(() => {
    if (!loading) return
    dispatch(onGetSellerStampsThunk({ dni, userType }))
  }, [userType])

  return error?.reason === 'FORBIDDEN_ERROR' || summaryError?.reason === 'FORBIDDEN_ERROR' ? null : (
    <Root>
      <Typography color="black1" fontWeight="bold" variant="h4">
        Sellos del proveedor
        {!loading && stamps?.length > 0 && (
          <MoreInformation>
            <Link
              href={`${REACT_APP_CENTROAYUDA_BASE_URL}/autoatencion/secciondeayuda/articulo/?c=CAT-01003&s=CAT-010031&a=KA-01686`}
              rel="noreferrer"
              target="_blank"
            >
              Más información
            </Link>
          </MoreInformation>
        )}
      </Typography>

      {loading && !error && <Skeleton height="50px" margin="2em 0 0" width="100%" />}

      {!loading && error && (
        <Toast
          disableBackground
          margin="17px 0"
          severity="default"
          title="Lo sentimos, estamos presentando problemas con nuestro servidor."
        >
          En estos momentos tenemos problemas para disponibilizar la información. Por favor, consulta en unos minutos
          más.
        </Toast>
      )}

      {!loading &&
        !error &&
        (!stamps?.length > 0 ? (
          <Typography color="black3" fontWeight="regular" margin="18px 0" variant="body2">
            Esta empresa proveedora no tiene sellos.
          </Typography>
        ) : (
          <Container>
            {stamps?.map((stamp, index) => (
              <Content key={index}>
                <Box>
                  <BookmarkIcon />
                </Box>
                <Box>
                  <Typography variant="body2">{stamp.name}</Typography>
                  {stamp.preSource === '' && <Typography variant="subtitle">Fuente: {stamp.source}</Typography>}
                  {stamp.preSource !== '' && (
                    <Typography variant="subtitle">
                      {stamp.preSource}. Fuente: {stamp.source}
                    </Typography>
                  )}
                </Box>
              </Content>
            ))}
          </Container>
        ))}

      <Separator />
    </Root>
  )
}

export default StampsSection
